import { RecorderClock, RecorderConfig } from 'modules/video-markers/domain/interfaces';
import { ObsRecorderClock } from './obs-recorder-clock';
import { VmixRecorderClock } from './vmix-recorder-clock';

/** Часы программы по настройке из `#`-фрагмента ссылки на табло. */
export function createRecorderClock(config: RecorderConfig): RecorderClock {
  switch (config.recorder) {
    case 'obs':
      return new ObsRecorderClock(config);
    case 'vmix':
      return new VmixRecorderClock(config);
  }
}
